// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"7003609b","714":"63bb6f79"}[chunkId] + ".chunk.js";
};